import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DialogOverViewComponent } from 'src/app/components/dialog-over-view/dialog-over-view.component';
import { DialogConfirmServiceService } from 'src/app/services/dialog-confirm-service.service';

@Component({
  selector: 'app-gestion-comm-area',
  templateUrl: './gestion-comm-area.component.html',
  styleUrls: ['./gestion-comm-area.component.scss']
})
export class GestionCommAreaComponent implements OnInit {

  // ======= public intervenantsSavList!: Intervenant[];
  form !: FormGroup;
  /* Display list */
  displayList: boolean = false;
  /* Message by default on display category list button  */
  message: string = "Afficher la liste";

  messageDialog : string = "";
  addMsg : string = "Élément ajouté";
  itemDeletedSuccessMsg : string = "Élément supprimé";
  itemDeletedFailureMsg : string = "Suppresion impossible";


  get displayedColumn(): string[] {
    const result: string[] = ['nom', 'edit', 'delete'];
    return result;
  }

  // =======newIntervenantSav: Intervenant = {
  //   intervenant_name: "",
  // };


  constructor( private builder: FormBuilder, private dialog: MatDialog, private confirmDialog: DialogConfirmServiceService) { }

  ngOnInit() {
    this.loadList();
    this.buildForm();
  }


  buildForm() {

    this.form = this.builder.group({
      nom: ['', Validators.required],
    })
  }


  /* GET the list of intervenants sav */
  public loadList() {
    // =======
    // this.service.getIntervenantsSav().subscribe(list => {
    //   // ====this.intervenantsSavList = list;

    //    /* Only display intervenants with deleted field equal to false. */
    //  this.intervenantsSavList =  this.intervenantsSavList.filter( function (el) {
    //   return el.deleted == false;
    // })

    //   return this.intervenantsSavList;
    // })

  // =====
  }

  public onClickVoirListe() {
    this.displayList = !this.displayList;
    if (!this.displayList) {
      this.message = "Afficher la liste";
    } else {
      this.message = "Masquer la liste";
    }

  }

  public onSubmit() {
    this.onCreate();
  }

  public onCreate() {
// ======
      // this.newIntervenantSav.intervenant_name = this.form.value.nom;
      // this.service.postIntervenantSav(this.newIntervenantSav).subscribe((data) => {
      //   this.messageDialog = this.addMsg;
      //   this.loadList();
      //   this.openMessageDialog();
      // }, (err) => {
      //   console.log('ERROR', err);
      // })
// ======
  }
// ==========
  // public onEdit(intervenant: Intervenant) {
  //   const dialogRef = this.dialog.open(EditGestionComponent, {
  //     data: {
  //       id: intervenant.intervenant_id,
  //       inputs: ['nom'],
  //       value: [intervenant.intervenant_name],
  //       form: this.form
  //     }
  //   });

  //   dialogRef.afterClosed().subscribe(
  //     res => {
  //       if (res != null) {
  //         let updateIntervenant: Intervenant = { intervenant_name: "" };
  //         updateIntervenant.intervenant_name = res.values[0];
  //         updateIntervenant.intervenant_id = res.values[1];

  //         this.service.editIntervenantSav(res.id, updateIntervenant).subscribe((data) => {
  //           this.loadList();
  //         }, (err) => {
  //           console.log('ERROR', err);
  //         })

  //       } 
  //     }
  //   )
  // }
// =====
// =====
  // public onDelete(id : number, intervenant: Intervenant) {
  //   this.confirmDialog.openConfirmDialog("Voulez-vous supprimer cet élément ?").afterClosed()
  //   .subscribe(res => {

  //     if (res) {
  //       this.service.deleteIntervenantSav(id, intervenant).subscribe((data) => {
  //         this.messageDialog = this.itemDeletedSuccessMsg;
  //         this.loadList();
  //         this.openMessageDialog();
  //       }, (err) => {
  //         console.log('ERROR', err);
  //         this.messageDialog = this.itemDeletedFailureMsg;
  //         this.openMessageDialog();
  //       })

  //     }

  //   });

  // }
// ======


   /* Alert user when new item is created  */
   public openMessageDialog(): any {
    this.dialog.open(DialogOverViewComponent, {
      width: '20%',
      data: { message: this.messageDialog }
    });
  }

}
